import React from "react";
import Section from "./Section";
import { Link } from "./../util/router";
import { useAuth } from "./../util/auth";
import logo from "./../assets/logo.jpg";
import hidevLogo from "./../assets/hidev_logo.png";

function Footer(props) {
  const auth = useAuth();

  return (
    <Section
      size={props.size}
      bgColor={props.bgColor}
      textColor={props.textColor}
      className={props.sticky && "mt-auto"}
    >
      <footer className="container">
        <div className="flex flex-col md:flex-row justify-between items-start mb-8 space-y-8 md:space-y-0">
          <div className="hidden md:flex md:flex-col md:items-start">
            <a href="https://sushiedomata.com" target="_blank" rel="noopener noreferrer">
              <img 
                src={logo} 
                alt="San Mateo Sushi Logo" 
                className="h-24 w-auto mb-4"
              />
            </a>
          </div>
          <div className="grid grid-cols-2 md:flex md:space-x-12 gap-8 md:gap-0 w-full md:w-auto">
            <div>
              <h4 className="text-sm uppercase font-semibold tracking-wider text-gray-400">
                Navigation
              </h4>
              <nav className="flex flex-col space-y-3 mt-6">
                <Link
                  to="/"
                  className="font-medium text-gray-600 hover:text-gray-500"
                >
                  Make Reservation
                </Link>
                <Link
                  to="/my-reservations"
                  className="font-medium text-gray-600 hover:text-gray-500"
                >
                  My Reservations
                </Link>
              </nav>
            </div>
            <div>
              <h4 className="text-sm uppercase font-semibold tracking-wider text-gray-400">
                Legal
              </h4>
              <nav className="flex flex-col space-y-3 mt-6">
                {[
                  { url: "/legal/terms-of-service", name: "Terms of Service" },
                  { url: "/privacy", name: "Privacy Policy" },
                ].map((link, index) => (
                  <Link
                    to={link.url}
                    className="font-medium text-gray-600 hover:text-gray-500"
                    key={index}
                  >
                    {link.name}
                  </Link>
                ))}
              </nav>
            </div>
            {auth.user && (
              <div>
                <h4 className="text-sm uppercase font-semibold tracking-wider text-gray-400">
                  Account
                </h4>
                <nav className="flex flex-col space-y-3 mt-6">
                  <Link
                    to="/settings/general"
                    className="font-medium text-gray-600 hover:text-gray-500"
                  >
                    Settings
                  </Link>
                  <Link
                    to="/admin"
                    className="font-medium text-gray-600 hover:text-gray-500"
                  >
                    Admin
                  </Link>
                </nav>
              </div>
            )}
          </div>
          <div className="hidden md:flex md:self-end">
            <a 
              href="https://hidevmobile.com" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <img 
                src={hidevLogo} 
                alt="HiDev Logo" 
                className="h-11 w-auto"
              />
            </a>
          </div>
        </div>
        
        {/* Mobile logos at the bottom */}
        <div className="md:hidden flex flex-col items-center mt-8 space-y-8">
          <a href="https://sushiedomata.com" target="_blank" rel="noopener noreferrer">
            <img 
              src={logo} 
              alt="San Mateo Sushi Logo" 
              className="h-24 w-auto"
            />
          </a>
          <a 
            href="https://hidevmobile.com" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img 
              src={hidevLogo} 
              alt="HiDev Logo" 
              className="h-12 w-auto"
            />
          </a>
        </div>
      </footer>
    </Section>
  );
}

export default Footer;
